import { default as DividerLine } from "components/Sidebar/Divider";

export const Divider = () => (
  <div style={{ paddingBottom: "32px" }}>
    <DividerLine />
  </div>
);
